export const normalizeRoomName = (room) => {
  const baseName = room?.label || room?.name || room?.roomTypeName || room?.title || ''
  const categories = Array.isArray(room?.categories)
    ? room.categories
        .map((item) => (typeof item === 'string' ? item : item?.name || item?.title || ''))
        .filter(Boolean)
        .join(' / ')
    : ''
  return categories ? `${baseName} | ${categories}` : baseName
}

export const mapPriceRuleItem = (item) => {
  const rawType = item.type || 'stay'
  const rawIsExpired = item.isExpired ?? item.is_expired
  const isExpired = rawIsExpired === true || rawIsExpired === 'true' || rawIsExpired === 1 || rawIsExpired === '1'

  return {
    id: item.id ?? null,
    title: item.title || item.name || '',
    minNight: Number(item.minNight ?? item.min_night) || 0,
    type: rawType,
    valueType: item.valueType || item.value_type || 'fixed',
    operator: item.operator === '+' ? '+' : '-',
    value: Number(item.value) || 0,
    roomTypeIds: Array.isArray(item.roomTypeIds) ? item.roomTypeIds : Array.isArray(item.roomTypes) ? item.roomTypes.map((room) => room.id) : [],
    startDate: item.startDate || item.start_date || item.validFrom || item.valid_from || null,
    endDate: item.endDate || item.end_date || item.validUntil || item.valid_until || null,
    validFrom: item.validFrom || item.valid_from || item.startDate || item.start_date || null,
    validUntil: item.validUntil || item.valid_until || item.endDate || item.end_date || null,
    state: typeof item.state === 'number' ? item.state : Number(item.state) || 0,
    isExpired,
  }
}

export const mapPagination = (pagination = {}, fallbackPage = 1, fallbackPerPage = 10) => ({
  total: Number(pagination.total ?? pagination.count ?? 0) || 0,
  currentPage: Number(pagination.currentPage ?? pagination.current_page ?? pagination.page ?? fallbackPage) || 1,
  perPage: Number(pagination.perPage ?? pagination.per_page ?? fallbackPerPage) || fallbackPerPage,
  lastPage: Number(pagination.lastPage ?? pagination.last_page ?? 1) || 1,
})

export const buildFetchParams = ({ filters, currentPage, pageSize }) => {
  const state = filters.state === '' ? undefined : Number(filters.state)
  const type = filters.type || undefined
  const operator = filters.operator || undefined
  const isExpired = filters.periodStatus === 'active' ? false : filters.periodStatus === 'expired' ? true : undefined

  return {
    page: currentPage,
    perPage: pageSize,
    state,
    type,
    operator,
    isExpired,
  }
}

export const formatDateString = (value) => {
  if (!value) return null
  if (typeof value === 'string') return value.slice(0, 10)
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return null
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const buildApiPayload = (form) => {
  const [rangeStart, rangeEnd] = Array.isArray(form.dateRange) ? form.dateRange : []
  const validFrom = formatDateString(form.validFrom || form.startDate || rangeStart)
  const validUntil = formatDateString(form.validUntil || form.endDate || rangeEnd)

  const apiType = form.type
  const payload = {
    title: form.title || '',
    type: apiType,
    valueType: form.valueType === '%' ? '%' : 'fixed',
    operator: form.operator === '+' ? '+' : '-',
    value: Number(form.value) || 0,
    roomTypeIds: Array.isArray(form.roomTypeIds) ? [...form.roomTypeIds] : [],
    state: Number(form.state) === 1 ? 1 : 0,
  }

  if (apiType === 'stay') {
    payload.minNight = Number(form.minNight) || 1
    payload.validFrom = null
    payload.validUntil = null
  } else {
    payload.minNight = null
    payload.validFrom = validFrom
    payload.validUntil = validUntil
  }

  return payload
}

export const buildPatchPayload = (current, original) => {
  const patch = {}
  Object.keys(current).forEach((key) => {
    const before = original?.[key]
    const after = current[key]

    if (Array.isArray(after)) {
      const beforeList = Array.isArray(before) ? before : []
      if (JSON.stringify(beforeList) !== JSON.stringify(after)) {
        patch[key] = after
      }
      return
    }

    if (before !== after) {
      patch[key] = after
    }
  })
  return patch
}

export const getSignedValue = (row) => {
  const value = Number(row.value) || 0
  if (value === 0) return 0
  return row.operator === '+' ? value : -value
}

export const isExpired = (row) => row?.isExpired === true

export const getPeriodStatus = (row) => {
  if (isExpired(row)) return 'expired'
  if (row?.type === 'stay') return 'active'
  const hasPeriodDate = Boolean(row?.startDate || row?.validFrom || row?.endDate || row?.validUntil)
  return hasPeriodDate ? 'active' : 'none'
}

export const getPeriodSortValue = (row) => {
  const periodStatus = getPeriodStatus(row)
  if (periodStatus === 'expired') return 2
  if (periodStatus === 'active') return 1
  return 0
}
